import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'
const vue = new Vue()

const state = {
  dispatchPlatformList: {},
  warehouseInfoList: {},
  warehouseInfo: {},
  warehouseInfoManage: 0,
  warehouseInfoManages: 0,
  varietiesList: [],
  supplierInfoList: {},
  supplierInfo: {},
  infoConfigList: {}
}
const actions = {
  [types.QUERYDISPATCHPLATFORM] (context, params) { // 查询配送平台
    http.fetch('/api/enterWarehouse/queryDispatchPlatform', params).then(data => {
      context.commit(types.QUERYDISPATCHPLATFORM, data)
    })
  },
  [types.DELETEENTERWAREHOUSE] (context, params) { // 删除
    http.fetch('/api/enterWarehouse/deleteEnterWarehouse', params).then(data => {
      context.commit(types.DELETEENTERWAREHOUSE, data)
    })
  },
  [types.INCREASEWAREHOUSE] (context, params) { // 新增
    http.fetch('/api/enterWarehouse/increaseWarehouse', params).then(data => {
      context.commit(types.INCREASEWAREHOUSE, data)
    })
  },
  [types.WAREHOUSEDETAILS] (context, params) { // 查询详细信息
    return new Promise((resolve, reject) => {
      http.fetch('/api/enterWarehouse/warehouseDetails', params).then(data => {
        if (data.code === 200) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  [types.SELECTWAREHOUSELIST] (context, params) { // 查询列表
    http.fetch('/api/enterWarehouse/selectWarehouseList', params).then(data => {
      context.commit(types.SELECTWAREHOUSELIST, data)
    })
  },
  [types.UPDATEYEWORDER] (context, params) { // 排序
    http.fetch('/api/enterWarehouse/updateYewOrder', params).then(data => {
      context.commit(types.UPDATEYEWORDER, data)
    })
  },
  [types.BATCHAUDIT] (context, params) { // 通过撤回等操作
    http.fetch('/api/enterWarehouse/batchAudit', params).then(data => {
      context.commit(types.BATCHAUDIT, data)
    })
  },
  [types.QUERYVARIETIES] (context, params) { // 查看主营品类
    http.fetch('/api/enterSupplier/queryVarieties', params).then(data => {
      context.commit(types.QUERYVARIETIES, data)
    })
  },
  [types.INCREASESUPPLIER] (context, params) { // 新增供应商
    http.fetch('/api/enterSupplier/increaseSupplier', params).then(data => {
      context.commit(types.INCREASESUPPLIER, data)
    })
  },

  [types.DELETEENTERSUPPLIER] (context, params) { // 删除供应商
    http.fetch('/api/enterSupplier/deleteEnterSupplier', params).then(data => {
      context.commit(types.DELETEENTERSUPPLIER, data)
    })
  },
  [types.BATCHAUDITSUPPLIER] (context, params) { // 通过or不通过
    http.fetch('/api/enterSupplier/batchAudit', params).then(data => {
      context.commit(types.BATCHAUDITSUPPLIER, data)
    })
  },
  [types.SELECTSUPPLIERLIST] (context, params) { // 供应商列表
    http.fetch('/api/enterSupplier/selectSupplierList', params).then(data => {
      context.commit(types.SELECTSUPPLIERLIST, data)
    })
  },
  [types.UPDATEYEWORDERBYSUPPLIER] (context, params) { // 排序
    http.fetch('/api/enterSupplier/updateYewOrder', params).then(data => {
      context.commit(types.UPDATEYEWORDERBYSUPPLIER, data)
    })
  },
  [types.SUPPLIERDETAILS] (context, params) { // 供应商详情
    return new Promise((resolve, reject) => {
      http.fetch('/api/enterSupplier/SupplierDetails', params).then(data => {
        if (data.code === 200) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  [types.UPDATEYCSHARECONFIG] (context, params) { // 信息配置 - 保存
    http.fetch('/api/shareConfig/updateYcShareConfig', params, 'application/json').then(data => {
      context.commit(types.UPDATEYCSHARECONFIG, data)
    })
  },
  [types.SELECTYCSHARECONFIG] (context, params) { // 信息配置 - 查询
    // http.fetch('/api/shareConfig/selectYcShareConfig', params).then(data => {
    //   context.commit(types.SELECTYCSHARECONFIG, data)
    // })
    return new Promise((resolve, reject) => {
      http.fetch('/api/shareConfig/selectYcShareConfig', params).then(data => {
        if (data.code === 200) {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

}
const mutations = {
  [types.QUERYDISPATCHPLATFORM] (state, data) {
    state.dispatchPlatformList = data
  },
  [types.DELETEENTERWAREHOUSE] (state, data) {
    if (data.code !== 200) return
    state.warehouseInfoManage = 1
    vue.$message({
      showClose: true,
      message: '删除成功',
      type: 'success'
    })
  },
  [types.INCREASEWAREHOUSE] (state, data) {
    if (data.code !== 200) return
    state.warehouseInfoManage = 1
    vue.$message({
      showClose: true,
      message: '操作成功',
      type: 'success'
    })
  },
  [types.WAREHOUSEDETAILS] (state, data) {
    state.warehouseInfo = data
  },
  [types.SELECTWAREHOUSELIST] (state, data) {
    state.warehouseInfoList = data
  },
  [types.BATCHAUDIT] (state, data) {
    if (data.code !== 200) return
    state.warehouseInfoManage = 1
  },
  [types.UPDATEYEWORDER] (state, data) {
    if (data.code !== 200) return
    state.warehouseInfoManage = 1
  },
  [types.DELETEENTERSUPPLIER] (state, data) {
    if (data.code !== 200) return
    state.warehouseInfoManages = 1
    vue.$message({
      showClose: true,
      message: '删除成功',
      type: 'success'
    })
  },
  [types.QUERYVARIETIES] (state, data) {
    state.varietiesList = data.obj
  },
  [types.SELECTSUPPLIERLIST] (state, data) {
    state.supplierInfoList = data
  },
  [types.SUPPLIERDETAILS] (state, data) {
    state.supplierInfo = data.obj
  },
  [types.BATCHAUDITSUPPLIER] (state, data) {
    if (data.code !== 200) return
    state.warehouseInfoManages = 1
  },
  [types.INCREASESUPPLIER] (state, data) {
    if (data.code !== 200) return
    state.warehouseInfoManages = 1
    vue.$message({
      showClose: true,
      message: '操作成功',
      type: 'success'
    })
  },
  [types.UPDATEYEWORDERBYSUPPLIER] (state, data) {
    if (data.code !== 200) return
    state.warehouseInfoManages = 1
  },
  [types.SELECTYCSHARECONFIG] (state, data) {
    state.infoConfigList = data
  },
  [types.UPDATEYCSHARECONFIG] (state, data) {
    if (data.code !== 200) return
    state.warehouseInfoManage = 1
    vue.$message({
      showClose: true,
      message: '操作成功',
      type: 'success'
    })
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/officialAccountManage/index.js